<template>
  <el-dialog
    title="审核信息"
    :visible.sync="auditInfoVisible"
    width="800px"
    :before-close="closeAuditInfoDia"
    :close-on-click-modal="false"
    class="audit-info"
    append-to-body
  >
    <div class="audit-cont">
      <el-form :model="auditForm" ref="auditForm" size="small">
        <el-row>
          <el-col :span="12">
            <el-form-item label-width="142px" label="所属部门：" prop="realName">
              <span>{{ auditForm.department }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label-width="142px" label="姓名：" prop="">
              {{ auditForm.name }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="142px" label="意见说明：" prop="realName">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入意见说明"
                v-model="auditForm.content"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="handle-btn">
        <div class="btn default-btn" @click="closeAuditInfoDia">取消</div>
        <el-button class="btn reset-btn" @click="approveHandle(2)" v-if="isAudit">驳回</el-button>
        <el-button class="btn reset-btn" @click="approveHandle(1)" v-if="isAudit">通过</el-button>

        <el-button class="btn reset-btn" @click="submitApprove" v-if="!isAudit">提交</el-button>
      </div>
    </div>
    <div class="list-box" v-if="isAudit">
      <div class="sub-title">审核记录</div>
      <el-table
        max-height="391"
        :data="tableData"
        ref="tableData"
        border
        size="small"
        style="width: 100%"
        :header-cell-style="{ background: '#F5F5F5' }"
        v-loading="tableLoading"
      >
        <el-table-column label="序号" width="60px">
          <template #default="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="memberRealName"
          label="审核人部门"
          min-width="70"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="approverRealName"
          label="审核人"
          min-width="70"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="logTime"
          label="审核时间"
          min-width="100"
          align="center"
        ></el-table-column>
        <el-table-column prop="" label="审核状态" min-width="90" align="center">
          <template #default="scope">
            <span>
              {{ scope.row.enquiryAuditStatus ? '审核通过' : '审核拒绝' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="approveStateDesc"
          label="意见说明"
          min-width="130"
          align="center"
        ></el-table-column>
      </el-table>
    </div>
    <!-- <div class="pagination-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :pager-count="5"
        :page-sizes="[10, 20, 30]"
        layout="total, prev, pager, next"
        :current-page="listQuery.pageNum"
        :total="total"
        :page-size.sync="listQuery.pageSize"
        prev-text="上一页"
        next-text="下一页"
      ></el-pagination>
    </div> -->
    <!-- <div slot="footer">
      <div class="default-btn btn" @click="closeAuditInfoDia">关闭</div>
    </div> -->
  </el-dialog>
</template>

<script>
import Api from '@/modules/projectA/api/purchase';
export default {
  props: {
    auditInfoVisible: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default() {
        return {};
      },
    },
    isAudit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tableLoading: false,
      auditForm: {
        department: '',
        content: '',
        name: '',
      },
      cloneSelectProductsForm: {},
      total: 0,
      tableData: [],
      idKey: 'skuid',
    };
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.USERINFO;
    },
  },
  watch: {
    auditInfoVisible(oldVal, newVal) {
      if (oldVal) {
        if (this.isAudit) {
          this.getList({ purchaseDemandId: this.row.purchaseDemandId });
        }
      }
    },
    mall_userInfo: {
      immediate: true,
      handler: function(newVal) {
        if (newVal.companyId) {
          this.auditForm.department = newVal.departmentName;
          this.auditForm.name = newVal.memberName;
        }
      },
    },
  },
  methods: {
    // approvePurchaseDemand
    /*

    @ApiModelProperty(value="采购商id")
    private Long purchaseCompanyId;

    @ApiModelProperty(value="采购需求id")
    private Long purchaseDemandId;

    @ApiModelProperty(value = "订单审批流Id")
    private Long workflowInstanceId;

    @ApiModelProperty(value = "审批状态 1 通过 2 不通过")
    @NotNull(fileName = "审批状态")
    private Short approveStatus;

    @ApiModelProperty(value = "审批内容")
    private String contents;
    */
    async approveHandle(approveStatus) {
      console.log(this.row, 'this.row');
      const params = {
        approveStatus,
        contents: this.auditForm.content,
        purchaseDemandId: this.row.purchaseDemandId,
        workflowInstanceId: this.row.workflowInstanceId,
      };
      this.$emit('approveHandle', params);
    },
    // 获取列表数据
    async getList(params) {
      this.tableLoading = true;
      await Api.queryPurchaseDemandApproveRecord(params).then(res => {
        this.tableLoading = false;
        if (res.code === '200') {
          this.tableData = res.data || [];
        }
      });
    },

    submitApprove() {
      this.$emit('submitApprove', this.auditForm.content);
    },

    closeAuditInfoDia() {
      this.$emit('update:auditInfoVisible', false);
    },
  },
};
</script>
<style lang="scss" scoped>
.audit-info {
  .search-form {
    display: flex;
    justify-content: center;
    ::v-deep .el-form-item {
      display: inline-block;
      margin-right: 10px;
      vertical-align: top;
    }
    ::v-deep .el-input__inner {
      border-radius: 0;
    }
  }
  .search-box {
    background: #fff;
    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 10px;
      margin-right: 20px;
    }
    .search-btn {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-bottom: 16px;

      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        cursor: pointer;
      }
    }
  }
  .list-box {
    .sub-title {
      color: #333;
      font-size: 14px;
      margin-bottom: 10px;
    }
  }

  .pagination-box {
    text-align: right;
    margin-top: 20px;
    ::v-deep .el-pagination {
      button {
        height: 30px;
        color: #999;
      }
      .el-select {
        .el-input__inner {
          border-radius: 0;
          height: 30px;
        }
      }
      .el-input__inner {
        border-radius: 0;
        height: 30px;
        color: #999;
      }
      .el-select-dropdown__item,
      .el-pagination__jump,
      .el-pagination__total {
        color: #999;
        line-height: 30px;
      }
      .el-pager {
        li {
          border-radius: 0;
          border: 1px solid #d9d9d9;
          line-height: 28px;
          text-align: center;
          margin-left: 10px;
          width: 40px;
          height: 30px;
          color: #999;
          &:first-child {
            margin-left: 0;
          }
          &.active {
            background: #2587ff;
            border: none;
            color: #fff;
          }
        }
      }
    }
  }
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 20px;
    }
    .el-dialog__footer div {
      display: flex;
      justify-content: center;
      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        cursor: pointer;
      }

      .default-btn {
        background: #fff;
        border: 1px solid #dcdfe6;
        &:hover {
          border-color: #2587ff;
          color: #2587ff;
        }
      }
    }
    .handle-btn {
      display: flex;
      justify-content: center;
      margin-bottom: 16px;
      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        cursor: pointer;
        padding: 0;
        border-radius: 0;
      }

      .default-btn {
        background: #fff;
        border: 1px solid #dcdfe6;
        &:hover {
          border-color: #2587ff;
          color: #2587ff;
        }
      }

      .reset-btn {
        background: #e8efff;
        border: 1px solid #2587ff;
        color: #2587ff;
        margin-left: 20px;
        line-height: 27px;
        &:hover,
        :active {
          background-color: #126edf;
          color: #fff;
        }
      }
    }
  }
}
// 列表重置样式-开始
::v-deep .el-table__header .cell {
  .icon-question {
    height: 18px;
    width: 18px;
    line-height: 18px;
    text-align: center;
    border-radius: 50%;
    border: 1px solid #c5c5c5;
    color: #c5c5c5;
    display: inline-block;
    margin-left: 10px;
    &:hover {
      color: #fff;
      background-color: #c5c5c5;
    }
  }
}
::v-deep .el-table__row .cell {
  font-size: 12px;
  white-space: normal;
  padding-left: 6px;
  padding-right: 6px;
  .el-button {
    font-size: 12px;
  }
  .el-input__inner {
    padding: 0 6px;
  }
  .edit-info {
    color: #c0c4cc;
  }
}
::v-deep .el-table--small td,
::v-deep .el-table--small th {
  padding: 6px 0;
}
::v-deep .el-table--small .el-table-column--selection {
  .cell {
    padding-left: 10px;
    padding-right: 10px;
    .el-checkbox__inner {
      border-radius: 0;
    }
  }
}
// 列表重置样式-结束

// dialog 重置样式开始
::v-deep.el-dialog__header {
  background: #f5f5f5;
  height: 40px;
  padding: 0 20px;
  line-height: 40px;
  .el-dialog__headerbtn {
    top: 9px;
  }
  .el-dialog__title {
    font-size: 14px;
  }
}
// dialog 重置样式结束
</style>
